import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29f58fd5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "dropdown-wrapper",
  ref: "dropdownRef"
}
const _hoisted_2 = { class: "selected-text" }
const _hoisted_3 = {
  key: 0,
  class: "dropdown-list"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["checked", "disabled", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "dropdown-selected",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.displaySelectedText || _ctx.placeholder), 1),
      _createVNode(_component_BaseIcon, {
        name: "chevron-down-dark",
        size: "14px",
        class: "dropdown-icon"
      })
    ]),
    (_ctx.showDropdown)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
            return (_openBlock(), _createElementBlock("li", {
              key: String(option.value),
              onClick: _withModifiers(($event: any) => (
          !(option.disabled || _ctx.isLimitReached(option.value)) &&
            _ctx.selectOption(option)
        ), ["stop"]),
              class: _normalizeClass({
          selected: _ctx.isSelected(option.value),
          disabled: option.disabled || _ctx.isLimitReached(option.value),
        })
            }, [
              (_ctx.multiple)
                ? (_openBlock(), _createElementBlock("input", {
                    key: 0,
                    type: "checkbox",
                    checked: _ctx.isSelected(option.value),
                    disabled: option.disabled || _ctx.isLimitReached(option.value),
                    class: "multi-checkbox",
                    onClick: _withModifiers(($event: any) => (
            !(option.disabled || _ctx.isLimitReached(option.value)) &&
              _ctx.selectOption(option)
          ), ["stop"])
                  }, null, 8, _hoisted_5))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(option.text), 1)
            ], 10, _hoisted_4))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 512))
}